import React from 'react';

const Footer = (props) => (
    <footer className='mt-5'>
        <p className='py-3 bg-primary text-light text-center'>Projet réalisé dans le cadre de l'Ecole H2PROG 05/2023</p>
    </footer>
)

export default Footer